import React, { Component, Fragment } from "react";
import {
  Button,
  TextField,
  Snackbar,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  Radio}
  from "@material-ui/core";
import {axios_instance} from '../../axios_instance';
import SaveIcon from "@material-ui/icons/Save";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { Autocomplete } from "@material-ui/lab";
import { Alert } from "@material-ui/lab";


class PreEnrolled extends Component {
  constructor(props) {
    super(props);
    this.state = {
      role_id: 9,
      terminos: false,
      email: "",
      role_time_out: false,
      time_out: false,
      time_out_school:false,
      time_out_city:false,
      edit: false,
      snack_open: false,
      snack_alert: "success",
      snack_openDestroy: false,
      checkedIdArray:[],
      materias:[],
      message_success: "",
      openAlert: false,
      cntper_id: 0,
      index: 0,
      tariffs: [],
      career: [],
      plan_selected: '',
      fcaradm_dueday: 0,
      contacts: [
        {
          cnttype_id: 1,
          cnttype_name: "Teléfono",
          cntper_data: "",
        },
        {
          cnttype_id: 2,
          cnttype_name: "Correo Electrónico",
          cntper_data: "",
        },
      ],
      contactType: [],
      careers: [],
      semesterModal: false,
      semesters: [],
      career_id: 0,
      tcareer_description: '',
      sems_id: 0,
      unit_type_id: 0,
      contactsEdit: [],
      contactsEdited: false,
      questions:[],
      answers: [],
      answerSelected: [],
      answersToRequest: [],
      roles: [],
      open: true,
      activeStep: 0,
      person_fname: "",
      person_lastname: "",
      person_shirtsize:'',
      homecity_id: '',
      homecity_name: "",
      hc_country_id: 0,
      hc_country_name: "pais de residencia",
      hc_depart_id: 0,
      hc_depart_name: "seleccione un departamento",
      hc_departments: [],
      hc_cities: [],
      birthplace_id: 0,
      birthplace_name: "ciudad de nacimiento",
      bp_country_id: 0,
      bp_country_name: "pais de origen",
      bp_depart_id: 0,
      bp_depart_name: "seleccione un departamento",
      bp_departments: [],
      bp_cities: [],
      country_id: 0,
      person_birthdate: "",
      person_gender: "",
      person_idnumber: "",
      person_address: "",
      person_bloodtype: "Tipo de sangre",
      person_business_name: "",
      person_ruc: "",
      stu_obs: "",
      stu_status: "Seleccione un estado",
      stu_status2: "Seleccione un estado",
      stu_gradyear: 0,
      stu_allergies: "",
      stu_instsupport: "",
      schools: [],
      school_id: 0,
      school_name: "",
      urlcareer: "/api-preinscript/precareers?fiter=false",
      hstitles: [],
      hstitle_id: 0,
      hstitle_name: "Titulo",
      country_name: "",
      person_photo: "",
      person_photo2: "",
      sucess: false,
      error: false,
      imagePreviewUrl: false,
      dropzone: false,
      countries: [],
      validator: {
        stu_gradyear: { message: "", error: false },
        stu_instsupport: { message: "", error: false },
        school_id: { message: "", error: false },
        hstitle_id: { message: "", error: false },
        stu_status2: { message: "", error: false },
        stu_status: { message: "", error: false },
        person_fname: { message: "", error: false },
        person_lastname: { message: "", error: false },
        homecity_id: { message: "", error: false },
        birthplace_id: { message: "", error: false },
        country_id: { message: "", error: false },
        person_birthdate: { message: "", error: false },
        person_gender: { message: "", error: false },
        person_idnumber: { message: "", error: false },
        person_address: { message: "", error: false },
        person_bloodtype: { message: "", error: false },
        person_business_name: { message: "", error: false },
        person_ruc: { message: "", error: false },
      },
    };

    this.handleOpenSemester = this.handleOpenSemester.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleCloseSemester = this.handleCloseSemester.bind(this);
    this.openDropzone = this.openDropzone.bind(this);
    this.closeDropzone = this.closeDropzone.bind(this);
    this.fieldsChange = this.fieldsChange.bind(this); //.person_fname, .person_lastname, .person_birthdate
    this.selectsChange = this.selectsChange.bind(this); // homecity_id:0,
    this.fieldChange13 = this.fieldChange13.bind(this); //person_photo
    this.fieldChange14 = this.fieldChange14.bind(this); //country_home_city
    this.fieldChange15 = this.fieldChange15.bind(this); //depart_home_city
    this.fieldChange16 = this.fieldChange16.bind(this); //country_bp
    this.fieldChange17 = this.fieldChange17.bind(this); //depart_bp
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubmit1 = this.handleSubmit1.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.closeSnack = this.closeSnack.bind(this);
    this.handleCloseAlert = this.handleCloseAlert.bind(this);
    this.destroy = this.destroy.bind(this);
    this.search = this.search.bind(this);
    this.getRetention = this.getRetention.bind(this);

    this.updateState = () => {
      this.setState({
        semesterModal: false,
      });
    };

  }
  handleCloseAlert() {
    this.setState({
      openAlert: false,
    });
  }
  handleNext() {
    this.setState({ activeStep: this.state.activeStep + 1 });
  }

  handleBack() {
    this.setState({ activeStep: this.state.activeStep - 1 });
  }

  handleReset() {
    this.setState({ activeStep: 0 });
  }

  handleOpen(data) {
    this.setState({
      openAlert: true,
      cnttype_name: data,
    });
  }
   handleOpenSemester()  {
    this.setState({semesterModal: true});
  };

   handleCloseSemester ()  {
    this.setState({semesterModal: false});
  };
  closeSnack() {
    this.setState({ snack_open: false });
  }
  openDropzone() {
    this.initialFile();
    this.setState({ dropzone: true });
  }
  closeDropzone() {
    this.setState({ dropzone: false });
  }
  handleClose() {
    this.setState({ open: false });
  }
  fieldsChange(e) {
    e.preventDefault();
    // console.log(e.target.name);
    this.setState({ [e.target.name]: e.target.value });
  }
  selectsChange(e, values, nameValue, nameLabel, route, obj) {
    // console.log(name);
    // console.log(nameValue+' '+nameLabel);
    // console.log(e);
    // console.log(values);
    if (route) {
      axios_instance.get("/api-preinscript/" + route + "/select/" + values.value).then((res) => {
        this.setState({ [obj]: res.data });
      });
    }
    this.setState({ [nameValue]: values.value, [nameLabel]: values.label });
  }
  fieldChange13(e) {
    if (e[0]) {
      // console.log(e[0]);
      this.createImage(e[0]);
    } else {
      this.setState({
        person_photo: "default.png",
        dropzone: false,
      });
    }
  }
  fieldChange14(e) {
    axios_instance.get("/api-preinscript/departments/select/" + e.value).then((res) => {
      this.setState({ hc_departments: res.data.data });
    });
    this.setState({ hc_country_id: e.value, hc_country_name: e.label });
  }
  fieldChange15(e) {
    axios_instance.get("/api-preinscript/cities/select/" + e.value).then((res) => {
      this.setState({ hc_cities: res.data });
    });
    this.setState({ hc_depart_id: e.value, hc_depart_name: e.label });
  }
  fieldChange16(e) {
    axios_instance.get("/api-preinscript/departments/select/" + e.value).then((res) => {
      this.setState({ bp_departments: res.data });
    });
    this.setState({ bp_country_id: e.value, bp_country_name: e.label });
  }
  fieldChange17(e) {
    axios_instance.get("/api-preinscript/cities/select/" + e.value).then((res) => {
      this.setState({ bp_cities: res.data });
    });
    this.setState({ bp_depart_id: e.value, bp_depart_name: e.label });
  }
  createImage(file) {
    let reader = new FileReader();
    reader.onload = (e) => {
      this.setState({
        person_photo: e.target.result,
        dropzone: false,
      });
    };
    reader.readAsDataURL(file);
    reader.onloadend = function (e) {
      this.setState({
        person_photo2: [reader.result],
      });
      // console.log([reader.result]);
    }.bind(this);
  }

  handleSubmit(e) {
    // console.log('this.state.person_shirtsize')
    // console.log(this.state.person_shirtsize)
    const {
      person_fname,
      person_lastname,
      country_id,
      homecity_id,
      person_idnumber,
      person_birthdate,
      person_gender,
      person_shirtsize,
      school_id,
      plan_selected,
      career,
      contacts
    } = this.state;
    e.preventDefault();
    var telefono = contacts.find(x=>{return parseInt(x.cnttype_id) === 1 && x.cntper_data !== ''});
    var correo = contacts.find(x=>{return parseInt(x.cnttype_id) === 2 && x.cntper_data.replace(/\s/g, '') !== ''});
    var talla = Boolean(person_shirtsize);
    var plan = (plan_selected === '' ? false : true);
    if(career.tcareer_id === 50003){
      correo = true;
    }else{
      talla = true;
    }
    // console.log('talla')
    // console.log(talla)
    if(person_fname === '' 
    || person_lastname === '' 
    || person_idnumber === '' 
    || person_birthdate === '' 
    || person_gender === ''
    || !Boolean(plan)
    || country_id === ''
    || homecity_id === ''
    || !Boolean(telefono)
    || !Boolean(correo)
    || !Boolean(talla)
    ){
      this.setState({snack_open: true, snack_alert:'error', message_success: 'Rellene los campos correctamente'})
    }else{
      var regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if(correo !== true && !regex.test(correo.cntper_data)){
        this.setState({snack_open: true, snack_alert:'error', message_success: 'El formato del correo no es valido'})
        return false;
      }
      axios_instance.post("/api-preinscript/students-preenrolled", {
        person_fname,
        person_lastname,
        country_id,
        homecity_id,
        person_idnumber,
        person_birthdate,
        person_gender,
        school_id,
        person_shirtsize,
        pplan_id:plan_selected,
        career_id: career.career_id,
        tcareer_id: career.tcareer_id
        })
        .then((res) => {
          var person = res.data.dato.person_id;
          axios_instance.post("/api-preinscript/contactPersons-per", {
            person_id: person,
            contacts: this.state.contacts,
          });
          this.setState({
            person_fname: "",
            person_lastname: "",
            homecity_id: 0,
            birthplace_id: 0,
            country_id: 0,
            person_birthdate: "",
            person_gender: "",
            person_idnumber: "",
            person_address: "",
            person_bloodtype: "",
            person_business_name: "",
            person_ruc: "",
            country_name: "",
            school_name: "",
            school_id: "",
            person_photo: "",
            snack_open:true,
            message_success:'Se guardo con exito',
            snack_alert: 'success',
            contacts: [
              {
                cnttype_id: 1,
                cnttype_name: "Telefono",
                cntper_data: "",
              }
            ],
          });
          this.handleClose();
        });
    }
  }
  handleSubmit1(e) {
    e.preventDefault();
    const {
      person_fname,
      person_lastname,
      person_shirtsize,
      birthplace_id,
      homecity_id,
      country_id,
      person_birthdate,
      person_gender,
      person_idnumber,
      person_address,
      person_bloodtype,
      person_business_name,
      person_ruc,
      person_photo,
      stu_obs,
      stu_status,
      stu_status2,
      stu_gradyear,
      stu_allergies,
      stu_instsupport,
      school_id,
      hstitle_id,
      plan_selected,
      career,
      contacts
    } = this.state;
    var telefono = contacts.find(x=>{return parseInt(x.cnttype_id) === 1 && x.cntper_data !== ''});
    var correo = contacts.find(x=>{return parseInt(x.cnttype_id) === 2 && x.cntper_data.replace(/\s/g, '') !== ''});
    var talla = Boolean(person_shirtsize);
    var plan = (plan_selected === '' ? false : true);
    if(career.tcareer_id === 50003){
      correo = true;
    }else{
      talla = true;
    }
    if(person_fname === '' 
    || person_lastname === '' 
    || person_idnumber === '' 
    || person_birthdate === '' 
    || person_gender === ''
    || !Boolean(plan)
    || country_id === ''
    || homecity_id === ''
    || !Boolean(telefono)
    || !Boolean(correo)
    || !Boolean(talla)
    ){
      this.setState({snack_open: true, snack_alert:'error', message_success: 'Rellene los campos correctamente'})
    }else{
    axios_instance
      .put(`/api-preinscript/students/${this.state.person_id}`, {
        person_fname,
        person_lastname,
        homecity_id,
        birthplace_id,
        country_id,
        person_birthdate,
        person_gender,
        person_idnumber,
        person_address,
        person_bloodtype,
        person_business_name,
        person_ruc,
        person_photo,
        person_shirtsize,
        stu_obs,
        stu_status,
        stu_status2,
        stu_gradyear,
        stu_allergies,
        stu_instsupport,
        school_id,
        hstitle_id,
        pplan_id: plan_selected,
        career_id: career.career_id,
        tcareer_id: career.tcareer_id
      })
      .then((res) => {
        if(res.data.dato != false){
          if (this.state.contactsEdit.length != 0) {
            axios_instance.post("/api-preinscript/contactPersons-per", {
              person_id: this.state.person_id,
              contacts: this.state.contactsEdit,
            });
          }

          if (this.state.contactsEdited === true) {
            axios_instance.put("/api-preinscript/contactPersons", {
              person_id: this.state.person_id,
              contacts: this.state.contacts,
            });
          }
          this.setState({snack_open: true, message_success: res.data, snack_alert: "success"});
          this.handleClose();
        }else{
          this.setState({snack_open: true, message_success: res.data.message, snack_alert: "error"});
        }

      });
    }
  }

  getcareers(){
    axios_instance.get(`${this.state.urlcareer}`).then((res) => {
      this.setState({ careers: res.data.data });
    });
  }

  componentDidMount() {
    if(this.props.match.params.career_id){
      // console.log(this.props.match.params.career_id);
      axios_instance.get(`/api-preinscript/careers/${this.props.match.params.career_id}`)
      .then((res=>{
        var response = res.data.data;
        if(response.tcareer_id === 50003){
          // console.log('acciones para correcaminata');
          var planes = response.current_plan;
          for(var i = 0; i < planes.length; i++){
            planes[i].pplan_details = JSON.parse(planes[i].pplan_obs);
          }
          response.current_plan = planes;
        }else{
          // console.log("carrera linea 450 PreEnrolled");
          // console.log(res.data)
        }
        // console.log("response");
        // console.log(response);
        this.setState({career: response})
      }))
    }else{
      console.log("nada");
    }
    // axios_instance.get("/api-preinscript/roles").then((res) => {
    //   this.setState({ roles: res.data.data });
    // });
    axios_instance.get("/api-preinscript/cities").then((res) => {
      this.setState({ hc_cities: res.data.data });
    });
    axios_instance.get("/api-preinscript/countries").then((res) => {
      this.setState({ countries: res.data.data });
    });
    this.getcareers()
    axios_instance.get("/api-preinscript/hstitle").then((res) => {
      this.setState({ hstitles: res.data.data });
    });
    axios_instance.get("/api-preinscript/schools").then((res) => {
      this.setState({ schools: res.data.data });
    });
    axios_instance.get("/api-preinscript/contactTypes").then((response) => {
      this.setState({
        contactType: response.data.data,
      });
    });
    if (this.props.edit) {
      const {
        person_fname,
        person_lastname,
        homecity_id,
        birthplace_id,
        country_id,
        person_birthdate,
        person_gender,
        person_idnumber,
        person_address,
        person_bloodtype,
        person_business_name,
        person_ruc,
        person_photo,
        country_name,
        stu_obs,
        stu_status,
        stu_status2,
        stu_gradyear,
        stu_allergies,
        stu_instsupport,
        school_id,
        school_name,
        hstitle_id,
        hstitle_name,
      } = this.props.person.data;

      axios_instance
        .get(`/api-preinscript/contactPersons-per/${this.props.person.data.person_id}`)
        .then((res) => {
          var cont = res.data.data;
          var values = [];
          if (cont.length != 0) {
            cont.forEach((item) => {
              values.push({
                cntper_id: item.cntper_id,
                cnttype_id: item.cnttype_id,
                cnttype_name: item.cnttype_name,
                cntper_data: item.cntper_data,
              });
            });
            this.setState({
              contacts: values,
            });
          } else {
            this.setState({ contactsEdit: this.state.contacts });
          }
        });
      axios_instance.get("/api-preinscript/cities/" + homecity_id).then((res) => {
        // console.log(res.data.data.city_name);
        this.setState({
          homecity_name: res.data.data.city_name,
          hc_country_id: res.data.data.country_id,
          hc_country_name: res.data.data.country_name,
          hc_depart_id: res.data.data.depart_id,
          hc_depart_name: res.data.data.depart_name,
        });
        axios_instance
          .get(`/api-preinscript/departments/select/${res.data.data.country_id}`)
          .then((res) => {
            // console.log(res.data);
            this.setState({ hc_departments: res.data });
          });
        axios_instance
          .get(`/api-preinscript/cities/select/${res.data.data.depart_id}`)
          .then((res) => {
            this.setState({ hc_cities: res.data });
          });
      });
      axios_instance.get("/api-preinscript/cities/" + birthplace_id).then((res) => {
        // console.log(res.data.data.city_name);
        this.setState({
          birthplace_name: res.data.data.city_name,
          bp_country_id: res.data.data.country_id,
          bp_country_name: res.data.data.country_name,
          bp_depart_id: res.data.data.depart_id,
          bp_depart_name: res.data.data.depart_name,
        });
        axios_instance
          .get(`/api-preinscript/departments/select/${res.data.data.country_id}`)
          .then((res) => {
            this.setState({ bp_departments: res.data });
          });
        axios_instance
          .get(`/api-preinscript/cities/select/${res.data.data.depart_id}`)
          .then((res) => {
            this.setState({ bp_cities: res.data });
          });
      });
      this.setState({
        person_fname,
        person_lastname,
        homecity_id,
        birthplace_id,
        country_id,
        person_birthdate,
        person_gender,
        person_idnumber,
        person_address,
        person_bloodtype,
        person_business_name,
        person_ruc,
        country_name,
        person_photo,
        person_photo2: `/img/${this.props.person.data.person_photo}`,
        stu_obs,
        stu_status,
        stu_status2,
        stu_gradyear,
        stu_allergies,
        stu_instsupport,
        school_id,
        school_name,
        hstitle_id,
        hstitle_name,
        edit: true,
      });
    }
  }
  Country() {
    return this.state.countries.map((data) => ({
      label: data.country_name,
      value: data.country_id,
    }));
  }
  HcDepartments() {
    if (this.state.hc_departments.length > 0) {
      return this.state.hc_departments.map((data) => ({
        label: data.depart_name,
        value: data.depart_id,
      }));
    } else {
      return [];
    }
  }
  HcCities() {
    if (this.state.hc_cities.length > 0) {
      return this.state.hc_cities.map((data) => ({
        label: data.city_name+' - '+ data.depart_name+' - '+ data.country_name,
        value: data.city_id,
      }));
    } else {
      return [];
    }
  }
  BpDepartments() {
    if (this.state.bp_departments.length > 0) {
      return this.state.bp_departments.map((data) => ({
        label: data.depart_name,
        value: data.depart_id,
      }));
    } else {
      return [];
    }
  }
  BpCities() {
    if (this.state.bp_cities.length > 0) {
      return this.state.bp_cities.map((data) => ({
        label: data.city_name,
        value: data.city_id,
      }));
    } else {
      return [];
    }
  }
  Schools() {
    return this.state.schools.map((data) => ({
      label: data.school_name,
      value: data.school_id,
    }));
  }
  Hstitles() {
    return this.state.hstitles.map((data) => ({
      label: data.hstitle_name,
      value: data.hstitle_id,
    }));
  }
  selectValue1() {
    // axios_instance.get('api/countries/'+this.state.country_id).then(res=>{
    //   this.setState({country_name: res.data.data});
    //   });
    return { label: this.state.country_name, value: this.state.country_id };
  }
  selectValue2() {
    return {
      label: this.state.hc_country_name,
      value: this.state.hc_country_id,
    };
  }
  selectValue3() {
    return { label: this.state.hc_depart_name, value: this.state.hc_depart_id };
  }
  selectValue4() {
    return { label: this.state.homecity_name, value: this.state.homecity_id };
  }
  selectValue5() {
    return {
      label: this.state.bp_country_name,
      value: this.state.bp_country_id,
    };
  }
  selectValue6() {
    return { label: this.state.bp_depart_name, value: this.state.bp_depart_id };
  }
  selectValue7() {
    return {
      label: this.state.birthplace_name,
      value: this.state.birthplace_id,
    };
  }
  selectValue8() {
    return { label: this.state.school_name, value: this.state.school_id };
  }
  selectValue9() {
    return { label: this.state.hstitle_name, value: this.state.hstitle_id };
  }
  selectValue(name, label) {
    return { label: this.state[name], value: this.state[label] };
  }
  initialFile() {
    if (this.props.edit) {
      return [`/img/${this.props.person.data.person_photo}`];
    } else if (this.state.person_photo2) {
      // console.log("es correcto");
      return [this.state.person_photo2];
    } else {
      return [];
    }
  }
  returnImage() {
    if (this.state.person_photo) {
      // console.log(this.state.person_photo);
    } else {
      return false;
    }
  }
  editOrNew() {
    if (this.state.edit) {
      return (
        <Button
          variant="outlined"
          color="primary"
          disabled={this.state.career.tcareer_id===50003 && !this.state.terminos}
          startIcon={<SaveIcon />}
          type="submit"
          onClick={this.handleSubmit1}
          style={{width: '80%', marginLeft: '10%', marginTop:20}}
        >
          Actualizar
        </Button>
      );
    } else {
      return (
        <Button
          variant="outlined"
          color="primary"
          disabled={this.state.career.tcareer_id===50003 && !this.state.terminos}
          startIcon={<SaveIcon />}
          type="submit"
          onClick={this.handleSubmit}
          style={{width: '80%', marginLeft: '10%', marginTop:20}}
        >
          Guardar
        </Button>
      );
    }
  }
  handleAddFields() {
    if (this.state.edit) {
      let values = [...this.state.contacts];
      values.push({ cnttype_id: 0, cnttype_name: "", cntper_data: "" });
      this.setState({ contacts: values });
      let values2 = [...this.state.contactsEdit];
      values2.push({ cnttype_id: 0, cnttype_name: "", cntper_data: "" });
      this.setState({ contactsEdit: values2 });
    } else {
      let values = [...this.state.contacts];
      values.push({ cnttype_id: 0, cnttype_name: "", cntper_data: "" });
      this.setState({ contacts: values });
    }
  }

  handleRemoveFields(index) {
    if (this.state.edit) {
      const values = [...this.state.contacts];
      this.setState({
        index: index,
        cntper_id: values[index].cntper_id,
      });
      this.handleOpen(values[index].cnttype_name);
    } else {
      var values = [...this.state.contacts];
      values.splice(index, 1);
      this.setState({ contacts: values });
    }
  }
  destroy() {
    // event.preventDefault();
    axios_instance.delete(`/api-preinscript/contactPersons/${this.state.cntper_id}`).then((res) => {
      var values = [...this.state.contacts];
      values.splice(this.state.index, 1);
      this.setState({
        snack_open: true,
        message_success: res.data.data,
        contacts: values,
      });
      this.handleAddFields();
    });
  }
  handleInputChange(index, event) {
    if (this.state.edit) {
      const values = [...this.state.contacts];
      const values2 = [...this.state.contactsEdit];
      var index2;
      if (values.length === values2.length) {
        index2 = index;
      } else if (values2.length != 0) {
        index2 = index - 1;

        if (event.target.name === "cntper_data") {
          // values[index].cntper_data = event.target.value;
          values2[index2].cntper_data = event.target.value;
        } else if (event.target.name === "cnttype_id") {
          // values[index].cnttype_id = event.target.value;
          values2[index2].cnttype_id = event.target.value;
        } else if (event.target.name === "cnttype_name") {
          values2[index2].cnttype_name = event.target.value;
          // values[index].cnttype_name = event.target.value;
        }
      }

      if (event.target.name === "cntper_data") {
        values[index].cntper_data = event.target.value;
        // values2[index2].cntper_data = event.target.value;
      } else if (event.target.name === "cnttype_id") {
        values[index].cnttype_id = event.target.value;
        // values2[index2].cnttype_id = event.target.value;
      } else if (event.target.name === "cnttype_name") {
        // values2[index2].cnttype_name = event.target.value;
        values[index].cnttype_name = event.target.value;
      }
      this.setState({
        contacts: values,
        contactsEdit: values2,
        contactsEdited: true,
      });
    } else {
      const values = [...this.state.contacts];
      if (event.target.name === "cntper_data") {
        values[index].cntper_data = event.target.value;
      } else if (event.target.name === "cnttype_id") {
        values[index].cnttype_id = event.target.value;
      } else if (event.target.name === "cnttype_name") {
        values[index].cnttype_name = event.target.value;
      }
      this.setState({ contacts: values });
    }
  }

  selectContacType() {
    return this.state.contactType.map((data) => ({
      label: data.cnttype_name,
      value: data.cnttype_id,
    }));
  }
  Roles() {
    return this.state.roles.map((data) => ({
      label: data.role_name,
      value: data.role_id,
    }));
  }
  onChangeContactType(e, values, index) {
    if (this.state.edit) {
      const value = [...this.state.contacts];
      const value2 = [...this.state.contactsEdit];
      var index2;
      if (value.length === value2.length) {
        index2 = index;
      } else if (value2.length != 0) {
        index2 = index - 1;
        value2[index2].cnttype_id = values.value;
        value2[index2].cnttype_name = values.label;
      }
      value[index].cnttype_id = values.value;
      // value2[index2].cnttype_id = values.value;
      value[index].cnttype_name = values.label;
      // value2[index2].cnttype_name = values.label;
      this.setState({
        contacts: value,
        contactsEdit: value2,
        contactsEdited: true,
      });
    } else {
      const value = [...this.state.contacts];
      value[index].cnttype_id = values.value;
      value[index].cnttype_name = values.label;
      this.setState({ contacts: value });
    }
  }

  search(event) {

    var e = event;
    this.setState({school_name: e.target.value})
    //funciona pero falta validar error 500
    e.persist();
    if (this.state.time_out_school == false) {
      this.setState({ time_out_school: true });
      setTimeout(() => {
        if (e.target.value === "") {
          this.getcareers();
          this.setState({time_out_school: false});
          // this.setState({
          //   filterEnrolleds: this.state.enrolleds.data,
          //   paginator: this.state.enrolleds,
          //   page_lenght: this.state.enrolleds.last_page,
          //   page: 1,
          //   time_out: false,
          // });
        } else {

          axios_instance
            .get(
              `/api-preinscript/schools-search/${e.target.value}`
            )
            .then((res) => {
              this.setState({
                schools: res.data.data,
                time_out_school: false,
              });
            })
            .catch((error) => {
              console.log("Ingrese un valor valido");
            });
        }
      }, 3000);
    }
  }

  searchCity(event){
    var e = event;
    this.setState({homecity_name: e.target.value})
    //funciona pero falta validar error 500
    e.persist();
    if (this.state.time_out_city == false) {
      this.setState({ time_out_city: true });
      setTimeout(() => {
        if (e.target.value === "") {
          this.getcareers();
          this.setState({time_out_city: false});
          // this.setState({
          //   filterEnrolleds: this.state.enrolleds.data,
          //   paginator: this.state.enrolleds,
          //   page_lenght: this.state.enrolleds.last_page,
          //   page: 1,
          //   time_out: false,
          // });
        } else {

          axios_instance
            .get(
              `/api-preinscript/cities/search/${e.target.value}`
            )
            .then((res) => {
              this.setState({
                hc_cities: res.data.data,
                time_out_city: false,
              });
            })
            .catch((error) => {
              console.log("Ingrese un valor valido");
            });
        }
      }, 3000);
    }
  }

  searchPerson(even) {
    var e = even;
    //funciona pero falta validar error 500
    e.persist();
    if (this.state.person_idnumber != "") {
      this.setState({ time_out: true });
      // setTimeout(() => {
        axios_instance
          .get(
            `/api-preinscript/students-search?filter[person_idnumber]=${this.state.person_idnumber}&all=false`
          )
          .then((res) => {
            if (res.data != false) {
              // var emplo_status2;

              axios_instance
                .get(`/api-preinscript/schools/${res.data.data[0].school_id}`)
                .then((res) => {
                  this.setState({
                    school_name: res.data.data.school_name,
                  });
                });
              axios_instance
                .get(`/api-preinscript/hstitle/${res.data.data[0].hstitle_id}`)
                .then((res) => {
                  this.setState({
                    hstitle_name: res.data.data.hstitle_name,
                  });
                });
              axios_instance
                .get(`/api-preinscript/countries/${res.data.data[0].country_id}`)
                .then((res) => {
                  this.setState({
                    country_name: res.data.data.country_name,
                  });
                });
              axios_instance
                .get(`/api-preinscript/cities/${res.data.data[0].homecity_id}`)
                .then((res) => {
                  this.setState({
                    homecity_name: res.data.data.city_name,
                    hc_country_id: res.data.data.country_id,
                    hc_country_name: res.data.data.country_name,
                    hc_depart_id: res.data.data.depart_id,
                    hc_depart_name: res.data.data.depart_name,
                  });
                });
              axios_instance
                .get(`/api-preinscript/cities/${res.data.data[0].birthplace_id}`)
                .then((res) => {
                  this.setState({
                    birthplace_name: res.data.data.city_name,
                    bp_country_id: res.data.data.country_id,
                    bp_country_name: res.data.data.country_name,
                    bp_depart_id: res.data.data.depart_id,
                    bp_depart_name: res.data.data.depart_name,
                  });
                });

              axios_instance
                .get(`/api-preinscript/contactPersons-per/${res.data.data[0].person_id}`)
                .then((res) => {
                  var cont = res.data.data;
                  var values = [];
                  if (cont.length != 0) {
                    cont.forEach((item) => {
                      values.push({
                        cntper_id: item.cntper_id,
                        cnttype_id: item.cnttype_id,
                        cnttype_name: item.cnttype_name,
                        cntper_data: item.cntper_data,
                      });
                    });
                    this.setState({
                      contacts: values,
                    });
                  } else {
                    this.setState({ contactsEdit: this.state.contacts });
                  }
                });
              // if (res.data.data[0].emplo_status) {
              //   emplo_status2 = "Activo";
              // } else {
              //   emplo_status2 = "Inactivo";
              // }
              this.setState({
                person_id: res.data.data[0].person_id,
                person_fname: res.data.data[0].person_fname,
                person_lastname: res.data.data[0].person_lastname,
                person_idnumber: res.data.data[0].person_idnumber,
                person_business_name: res.data.data[0].person_business_name,
                person_birthdate: res.data.data[0].person_birthdate,
                person_ruc: res.data.data[0].person_ruc,
                person_address: res.data.data[0].person_address,
                person_bloodtype: res.data.data[0].person_bloodtype,
                person_gender: res.data.data[0].person_gender,
                person_photo: res.data.data[0].person_photo,
                person_photo2: `/img/${res.data.data[0].person_photo}`,
                country_id: res.data.data[0].country_id,
                homecity_id: res.data.data[0].homecity_id,
                birthplace_id: res.data.data[0].birthplace_id,
                stu_status: res.data.data[0].stu_status,
                stu_gradyear: res.data.data[0].stu_gradyear,
                stu_obs: res.data.data[0].stu_obs,
                stu_allergies: res.data.data[0].stu_allergies,
                stu_instsupport: res.data.data[0].stu_instsupport,
                school_id: res.data.data[0].school_id,
                hstitle_id: res.data.data[0].hstitle_id,
                stu_status2: res.data.data[0].stu_status2,
                time_out: false,
                edit: true,
              });
            } else {
              this.setState({
                contacts: [
                  {
                    cnttype_id: 1,
                    cnttype_name: "Telefono",
                    cntper_data: "",
                  },
                  {
                    cnttype_id: 2,
                    cnttype_name: "Correo Electronico",
                    cntper_data: "",
                  },
                ],
                edit: false,
                time_out: false,
                person_fname: "",
                person_lastname: "",
                homecity_id: 0,
                homecity_name: "",
                hc_country_id: 0,
                hc_country_name: "pais de residencia",
                hc_depart_id: 0,
                hc_depart_name: "seleccione un departamento",
                birthplace_id: 0,
                birthplace_name: "ciudad de nacimiento",
                bp_country_id: 0,
                bp_country_name: "pais de origen",
                bp_depart_id: 0,
                bp_depart_name: "seleccione un departamento",
                country_id: 0,
                person_birthdate: "2000-01-01",
                person_gender: "Seleccione su sexo",

                person_address: "",
                person_bloodtype: "Tipo de sangre",
                person_business_name: "",
                person_ruc: "",
                stu_obs: "",
                stu_status: "Seleccione un estado",
                stu_status2: "Seleccione un estado",
                stu_gradyear: 0,
                stu_allergies: "",
                stu_instsupport: "",
                school_id: 0,
                school_name: "",
                country_name: "",
                person_photo: "",
                person_photo2: "",
                validator: {
                  stu_gradyear: { message: "", error: false },
                  stu_instsupport: { message: "", error: false },
                  school_id: { message: "", error: false },
                  hstitle_id: { message: "", error: false },
                  stu_status2: { message: "", error: false },
                  stu_status: { message: "", error: false },
                  person_fname: { message: "", error: false },
                  person_lastname: { message: "", error: false },
                  homecity_id: { message: "", error: false },
                  birthplace_id: { message: "", error: false },
                  country_id: { message: "", error: false },
                  person_birthdate: { message: "", error: false },
                  person_gender: { message: "", error: false },
                  person_idnumber: { message: "", error: false },
                  person_address: { message: "", error: false },
                  person_bloodtype: { message: "", error: false },
                  person_business_name: { message: "", error: false },
                  person_ruc: { message: "", error: false },
                }
              })
            }
          });
    //   }, 3000);
  }else{
    this.setState({
      contacts: [
        {
          cnttype_id: 1,
          cnttype_name: "Telefono",
          cntper_data: "",
        },
        {
          cnttype_id: 2,
          cnttype_name: "Correo Electronico",
          cntper_data: "",
        },
      ],
      edit: false,
      time_out: false,
      person_fname: "",
      person_lastname: "",
      homecity_id: 0,
      homecity_name: "",
      hc_country_id: 0,
      hc_country_name: "pais de residencia",
      hc_depart_id: 0,
      hc_depart_name: "seleccione un departamento",
      birthplace_id: 0,
      birthplace_name: "ciudad de nacimiento",
      bp_country_id: 0,
      bp_country_name: "pais de origen",
      bp_depart_id: 0,
      bp_depart_name: "seleccione un departamento",
      country_id: 0,
      person_birthdate: "2000-01-01",
      person_gender: "Seleccione su sexo",
      person_address: "",
      person_bloodtype: "Tipo de sangre",
      person_business_name: "",
      person_ruc: "",
      stu_obs: "",
      stu_status: "Seleccione un estado",
      stu_status2: "Seleccione un estado",
      stu_gradyear: 0,
      stu_allergies: "",
      stu_instsupport: "",
      school_id: 0,
      school_name: "",
      country_name: "",
      person_photo: "",
      person_photo2: "",
      validator: {
        stu_gradyear: { message: "", error: false },
        stu_instsupport: { message: "", error: false },
        school_id: { message: "", error: false },
        hstitle_id: { message: "", error: false },
        stu_status2: { message: "", error: false },
        stu_status: { message: "", error: false },
        person_fname: { message: "", error: false },
        person_lastname: { message: "", error: false },
        homecity_id: { message: "", error: false },
        birthplace_id: { message: "", error: false },
        country_id: { message: "", error: false },
        person_birthdate: { message: "", error: false },
        person_gender: { message: "", error: false },
        person_idnumber: { message: "", error: false },
        person_address: { message: "", error: false },
        person_bloodtype: { message: "", error: false },
        person_business_name: { message: "", error: false },
        person_ruc: { message: "", error: false },
      }
    })
  }
  }

  getRetention(id){
    axios_instance
      .get("/api-preinscript/retentionQuestionParameters/" + id)
      .then((response) => {
        this.setState({
          questions: response.data.data,
        });
      });
  }

  getSemesters(id){
    axios_instance
      .get("/api-preinscript/semesters/career/" + id)
      .then((res) => {
        if (res !== false) {
          this.setState({
            semesters: res.data.data,
            semesterModal: true
          });
        }

      });
  }

  getSubject(id){
    this.setState({checkedIdArray:[]})
    axios_instance
        .get(
          `/api-preinscript/carsubject/semester/${id}`
        )
        .then((res) => {
          this.setState({
            materias: res.data.data,
          });
          res.data.data.forEach((item, i) => {
              this.setState({
                checkedIdArray: [...this.state.checkedIdArray, item.carsubj_id],
              });
          });
        });
  }





  onCheck(student_ret_par_id, student_ret_quet_id, parameter_value) {
    var index;
    var array;
      if (this.state.answers.includes(student_ret_par_id)) {
         index = this.state.answersToRequest.findIndex(
          (val) => val["student_ret_par_id"] === student_ret_par_id
        );
        array = this.state.answersToRequest;
        array.splice(index,1)
        this.setState({
          answersToRequest: array,
          answers: this.state.answers.filter(
            (val) => val !== student_ret_par_id
          ),
        });
      } else {
        var input = [
          {
            parameter_value: parameter_value,
            student_ret_quet_id: student_ret_quet_id,
            student_ret_par_id: student_ret_par_id,
          },
        ];
        this.setState({
          answers: [...this.state.answers, student_ret_par_id],
          answersToRequest: [...this.state.answersToRequest, ...input],
        });
      }

  }
  calcularEdad(fechaNacimiento) {
    var hoy = new Date("2025-12-31");
    var fechaNac = new Date(fechaNacimiento);
    var edad = hoy.getFullYear() - fechaNac.getFullYear();
    var mes = hoy.getMonth() - fechaNac.getMonth();
    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
      edad--;
    }
    return edad;
  }
  render() {
    const {
      person_fname,
      person_lastname,
      person_idnumber,
      person_birthdate
    } = this.state;

    var showSnackDestoy;

    if (this.state.snack_open) {
      showSnackDestoy = (
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "right"
          }}
          open={this.state.snack_open}
          autoHideDuration={6000}
          onClose={this.closeSnack}
        >
          <Alert
            elevation={6}
            variant="filled"
            onClose={this.closeSnack}
            severity={this.state.snack_alert}
          >
            {this.state.message_success}
          </Alert>
        </Snackbar>
      );
    }
    return (
      <div className="paper-body">
      <div className="paper-main">
        {this.state.career != false?
          <div>
            {(this.state.career.career_logo !== 'default.png' && this.state.career.career_logo !== 'blank.jpg')?
              <div
                style={{height: 200, width:'100%', textAlign: 'center'}}
              >
              {/*<img style={{height: '100%', margin: 'auto'}} src={`/img/unaelogo.jpeg`} alt="Logo" />*/}
                <img style={{height: '100%',width:'80%', margin: 'auto'}} src={`/img/${this.state.career.career_logo}`} alt="Logo" />
              </div>
            :
            <div
              style={{height: 200, width:'100%', textAlign: 'center'}}
              >
              <img style={{height: '100%', margin: 'auto'}} src={`/img/unaelogo.jpeg`} alt="Logo" />
            </div>
          }
            <h3 align="center" style={{paddingTop: 20}}>{`Pre Inscripción - ${this.state.career.career_name}`}</h3>
          </div>
        :
        <h3 align="center" style={{paddingTop: 20}}>Pre Inscripción</h3>
        }

        <div>
        <TextField
                  id="outlined-basic"
                  margin="normal"
                  label="Cédula *"
                  size="small"
                  className="textField-preinscript"
                  value={person_idnumber}
                  name="person_idnumber"
                  onChange={(event) => (
                    this.fieldsChange(event)
                    )}
                  onBlur={(e)=>{this.searchPerson(e)}}
                  variant="outlined"
                  style={{width: '80%', marginLeft: '10%'}}
                  InputProps={{
                    endAdornment: (
                      <React.Fragment>
                        {this.state.time_out === true ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                      </React.Fragment>
                    ),
                  }}
                />
                  <TextField
                    id="outlined-basic"
                    label="Nombres *"
                    margin="normal"
                    size="small"
                    className="textField-preinscript"
                    name="person_fname"
                    value={person_fname}
                    onChange={this.fieldsChange.bind(this)}
                    variant="outlined"
                    style={{width: '80%', marginLeft: '10%'}}
                  />

                  <TextField
                    id="outlined-basic"
                    margin="normal"
                    label="Apellidos *"
                    size="small"
                    className="textField-preinscript"
                    value={person_lastname}
                    name="person_lastname"
                    onChange={this.fieldsChange.bind(this)}
                    variant="outlined"
                    style={{width: '80%', marginLeft: '10%'}}
                  />
                  <TextField
                    id="outlined-basic"
                    margin="normal"
                    type="date"
                    size="small"
                    label="Fecha de Nacimiento *"
                    className="textField-preinscript"
                    value={person_birthdate}
                    name="person_birthdate"
                    onChange={this.fieldsChange.bind(this)}
                    variant="outlined"
                    style={{width: '80%', marginLeft: '10%'}}
                    InputLabelProps={{ shrink: true }}
                  />
              <FormControl
                variant="outlined"
                size="small"
                margin="normal"
                style={{ width: '80%', marginLeft: '10%'}}
                inputlabelprops={{
                  shrink: true,
                }}
              >
                <InputLabel htmlFor="demo-simple-select-outlined" style={{backgroundColor: 'white', padding: '0 5px'}} shrink={true}>Género *</InputLabel>
                <Select
                  native
                  label="Género"
                  value={this.state.person_gender}
                  inputProps={{
                    name:"Género",
                    id: "demo-simple-select-helper",
                  }}
                  onChange={(e)=>{
                    this.setState({person_gender: e.target.value})
                  }}
                >
                        <option value={''}>{"Seleccione una opción"}</option>
                        <option value={'M'}>{"Masculino"}</option>
                        <option value={'F'}>{"Femenino"}</option>
                </Select>
              </FormControl>
              <Autocomplete
                id="combo-box-demo"
                disableClearable
                options={this.Country()}
                getOptionLabel={(option) => option.label}
                onChange={(e, values) =>
                  this.selectsChange(e, values, "country_id", "country_name")
                }
                value={this.selectValue("country_name", "country_id")}
                getOptionSelected={(option, value) => {
                  if (value === option.value) {
                    return option.label;
                  } else {
                    return false;
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="País de Nacionalidad *"
                    error={this.state.validator.country_id.error}
                    helperText={this.state.validator.country_id.message}
                    className="textField-preinscript"
                    variant="outlined"
                    margin="normal"
                    size="small"
                    style={{width: '80%', marginLeft: '10%'}}
                  />
                )}
              />
<Autocomplete
                id="combo-box-demo"
                disableClearable
                options={this.HcCities()}
                // options={[this.selectValue("homecity_name", "homecity_id"), ...this.HcCities()]}
                getOptionLabel={(option) => option.label}
                onChange={(e, values) =>
                  this.selectsChange(e, values, "homecity_id", "homecity_name")
                }
                value={this.selectValue("homecity_name", "homecity_id")}
                getOptionSelected={(option, value) => {
                  if (value === option.value) {
                    return option.label;
                  } else {
                    return false;
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Ciudad de Residencia *"
                    error={this.state.validator.homecity_id.error}
                    helperText={this.state.validator.homecity_id.message}
                    className="textField-preinscript"
                    variant="outlined"
                    margin="normal"
                    onChange={(e)=>{this.searchCity(e)}}
                    size="small"
                    style={{width: '80%', marginLeft: '10%'}}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {this.state.time_out_city === true ? (
                            <CircularProgress color="inherit" size={20} />
                          ) : null}
                        </React.Fragment>
                      ),
                    }}
                  />
                )}
              />
                  {/* <Autocomplete
                    id="combo-box-demo"
                    disableClearable
                    options={[this.selectValue("school_name", "school_id"), ...this.Schools()]}
                    getOptionLabel={(option) => option.label}
                    onChange={(e, values) =>
                      this.selectsChange(e, values, "school_id", "school_name")
                    }
                    value={this.selectValue("school_name", "school_id")}
                    getOptionSelected={(option, value) => {
                      if (value === option.value) {
                        return option.label;
                      } else {
                        return false;
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Institución"
                        error={this.state.validator.school_id.error}
                        className="textField-preinscript"
                        onChange={(e)=>{this.search(e)}}
                        variant="outlined"
                        margin="normal"
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {this.state.time_out_school === true ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}
                        style={{width: '80%', marginLeft: '10%'}}
                      />
                    )}
                  /> */}

            {this.state.contacts.map((inputField, index) => (


              <Fragment key={`${inputField}~${index}`}>


                    <TextField
                      variant="outlined"
                      className="textField-preinscript"
                      id="cntper_data"
                      name="cntper_data"
                      size="small"
                      type={inputField.cnttype_id === 2? 'email' : 'text'}
                      value={inputField.cntper_data}
                      onChange={(event) => this.handleInputChange(index, event)}
                      label={inputField.cnttype_name}
                      margin="normal"
                      style={{width: '80%', marginLeft: '10%'}}
                    />

                </Fragment>


              ))}
            {this.state.career.tcareer_id === 50003 && (
              <div>
                <FormControl
                  variant="outlined"
                  size="small"
                  margin="normal"
                  style={{ width: '70%', marginLeft: '10%'}}
                  inputlabelprops={{
                    shrink: true,
                  }}
                >
                  <InputLabel htmlFor="demo-simple-select-outlined" style={{backgroundColor: 'white', padding: '0 5px'}} shrink={true}>Talla de remera *</InputLabel>
                  <Select
                    native
                    label="Talla de remera"
                    value={this.state.person_shirtsize}
                    inputProps={{
                      name:"Talla de remera",
                      id: "demo-simple-select-helper",
                    }}
                    onChange={(e)=>{
                      this.setState({person_shirtsize: e.target.value})
                    }}
                  >
                          <option value={''}>{"Seleccione una opción"}</option>
                          <option value={'P'}>{"P"}</option>
                          <option value={'M'}>{"M"}</option>
                          <option value={'G'}>{"G"}</option>
                          <option value={'GG'}>{"GG"}</option>
                  </Select>
                </FormControl>
		    {/* <Button
                  variant="outlined"
                  color="primary"
                  type="submit"
                  onClick={()=>{window.open(`/img/promos/talla_remera.jpeg`)}}
                  style={{width: '10%', marginLeft: '0', marginTop:16, paddingTop: '9px'}}
                >
                  <VisibilityIcon />
                </Button>*/}
              </div>
            )}
              {/*aqui van los radio buton si tiene plan de pago*/}
              {this.state.career.tcareer_id===50003?
              <div style={{width: '80%', marginLeft: '10%'}}>
                <h3 align="center">Categorías</h3>
                <ul>
                  <li style={{listStyle:"square"}}><span>Participación competitiva | Gs. 60.000</span>
                    <ul>
                      {this.state.career.current_plan.filter(x=>parseInt(x.pplan_details.cate_id) ===3 && (this.calcularEdad(this.state.person_birthdate)>=x.pplan_details.edad_min && (this.calcularEdad(this.state.person_birthdate)<=x.pplan_details.edad_max || x.pplan_details.edad_max == ">"))).map((row2, index_r2)=>{
                        console.log('row2.pplan_details');
                        console.log(row2.pplan_details);
                        if(row2.pplan_details.gender !== undefined){
                          if(row2.pplan_details.gender === this.state.person_gender){
                            return(
                              <li style={{listStyle:"none"}} key={index_r2}>
                                <Radio
                                checked={row2.pplan_id===this.state.plan_selected}
                                onChange={()=>this.setState({plan_selected: row2.pplan_id})}
                                value={row2.pplan_id}
                                />
                                {row2.pplan_desc}
                              </li>
                            )
                          }
                        }else{
                          return(
                            <li style={{listStyle:"none"}} key={index_r2}>
                              <Radio
                              checked={row2.pplan_id===this.state.plan_selected}
                              onChange={()=>this.setState({plan_selected: row2.pplan_id})}
                              value={row2.pplan_id}
                              />
                              {row2.pplan_desc}
                            </li>
                          )
                        }
                        })}
                    </ul>
                  </li>
                  <li style={{listStyle:"square"}}><span>Compra de remera sin competición | Gs. 60.000</span>
                    <ul>
                      {this.state.career.current_plan.filter(x=>parseInt(x.pplan_details.cate_id) ===1).map((row1, index_r1)=>(
                        <li style={{listStyle:"none"}} key={index_r1}>
                          <Radio
                            checked={row1.pplan_id===this.state.plan_selected}
                            onChange={()=>this.setState({plan_selected: row1.pplan_id})}
                            value={row1.pplan_id}
                            />
                          {row1.pplan_desc}
                        </li>
                      ))}
                    </ul>
                  </li>
                  <li style={{listStyle:"square"}}>
                    {/*<span>Otros</span>*/}
                    <ul>
                      {this.state.career.current_plan.filter(x=>parseInt(x.pplan_details.cate_id) ===2).map((row3, index_r3)=>{
                        return(
                          <li style={{listStyle:"none"}} key={index_r3}>
                            <Radio
                            checked={row3.pplan_id===this.state.plan_selected}
                            onChange={()=>this.setState({plan_selected: row3.pplan_id})}
                            value={row3.pplan_id}
                            />
                            {row3.pplan_desc}
                          </li>
                      )})}
                    </ul>    
                  </li>
                </ul>
              </div>
              :this.state.career != false ?
                <div style={{width: '80%', marginLeft: '10%'}}>
                  {this.state.career.current_plan.length > 0 ?
                  <div>
			{parseInt(this.props.match.params.career_id) === 50435?

                  <h3 align="center">Aranceles con descuento:</h3>
			:<h3 align="center">Aranceles:</h3>
			}
                  {
                    this.state.career.current_plan.map((row, index)=>{
                      return(
                        <div key={row.pplan_id}>
                          <Radio
                            checked={row.pplan_id===this.state.plan_selected}
                            onChange={()=>this.setState({plan_selected: row.pplan_id})}
                            value={row.pplan_id}
                            />
                            <label>{`${row.pplan_desc}`}</label>
                        </div>
                      )
                    })
                  }
                  </div>
                  :
                  ''}
                  {this.state.career.next_plan.length > 0 ?
                  <div>
                  <h3 align="center">Aranceles regulares:</h3>

                    {this.state.career.next_plan.map((row, index)=>{
                      var fecha = new Date(row.pplan_start_date);
                      return(
                        <div key={row.pplan_id}>
                          {/*<Radio
                            checked={row.pplan_id===this.state.plan_selected}
                            onChange={()=>this.setState({plan_selected: row.pplan_id})}
                            value={row.pplan_id}
                            />*/}
                            <label>{`${row.pplan_desc}`}</label>
                        </div>
                      )
                    })
                  }
                  </div>
                  :
                  ''}
                </div>

              :
              ''
              }
            {this.state.career.tcareer_id===50003&&(
              <div style={{width: '80%', marginLeft:'10%', float:'left'}}>
                <p style={{color:'black'}}>
                  <input type="checkbox" checked={this.state.terminos} onChange={()=>this.setState({terminos:!this.state.terminos})} />
                  Aceptar <span style={{textDecoration:'underline'}} onClick={()=>window.open("https://unae.edu.py/tv/images/2025/Terminos-y-condiciones-correcaminata-2025-encarnacion.pdf")}>términos y condiciones</span> de participación</p>
              </div>
            )}
            {this.editOrNew()}
            {this.state.career.tcareer_id===50003?
	            <img style={{width:"100%"}} src="/img/promos/metodo_pago50003.jpeg" />
            : <img style={{width:"100%"}} src="/img/promos/metodo_pago6.jpeg" />
            }
          </div>
      {showSnackDestoy}
      </div>
      </div>
    );
  }
}
export default PreEnrolled;
